class StickyATC extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const mobileShowAfter = 600;
    const tabletShowAfter = 800;
    const desktopShowAfter = 300;

    this.sticky = this.querySelector(".sticky-atc");
    this.isArticleBar = this.dataset.article === "true";

    const articleAuthor = document.querySelector(".article-author");

    const getShowAfter = () => {
      const width = window.innerWidth;
      if (width < 640) return mobileShowAfter;
      if (width < 1024) return tabletShowAfter;
      return desktopShowAfter;
    };

    const onScroll = () => {
      const showAfter = getShowAfter();
      const scrollY = window.scrollY;

      const shouldShow = scrollY > showAfter;
      let shouldHide = false;

      if (articleAuthor) {
        const authorBottom =
          articleAuthor.getBoundingClientRect().bottom + window.scrollY;
        shouldHide = scrollY + window.innerHeight > authorBottom;
      }

      if (shouldShow && !shouldHide) {
        this.sticky.classList.add("active");
      } else {
        this.sticky.classList.remove("active");
      }
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);

    onScroll();
  }
}

customElements.define("sticky-atc", StickyATC);
